import router from '../../router';
import store from '../../store/store';
import userAgent from '../helpers/userAgent';
import useSessionStorage from '../helpers/useSessionStorage';
import onboardingService from '../services/onboardingService';
import userOnboardingService from '../services/userOnboardingService';

// Get default OPTIONS in vue-tour
const modifiersDefault = [
    {
        name: 'arrow',
        options: {
            element: '.v-step__arrow',
            padding: 10,
        },
    },
    {
        name: 'preventOverflow',
        options: {
            rootBoundary: 'window',
        },
    },
    {
        name: 'offset',
        options: {
            offset: [0, 10],
        },
    },
];

// Modifier flip popover
const flipModifier = (options = {fallbackPlacements: []}) => [
    {
        name: 'flip',
        options: {
            rootBoundary: 'document',
            ...options,
        },
    },
];

export default {
    /**
     * Configurations tutorials list here to display in remind and choice modal
     * Default here always 'checked' and 'completed' property is false
     * It will change after fetch api and get saved data
     */
    tutorials: [
        {
            checked: false,
            completed: false,
            text: 'Tạo Hình thức quảng cáo',
            id: 'advertisement',
        },
        {
            checked: false,
            completed: false,
            text: 'Tạo link đẩy chiến dịch',
            id: 'create_link',
        },
    ],

    /**
     * Configurations steps list of tutorials list above
     * Remember steps list will interactive with
     * vue-onboarding-step component by target
     */
    steps: {
        advertisement: [
            {
                target: '[data-obd-advertisement-step="1"]',
                header: {
                    title: 'Bước 1',
                    closeable: () => store.state.vueOnboarding.onboarding.flow === 'A',
                    confirmable: true,
                    confirmCallback: () => {
                        userOnboardingService.hold({step: 1, tutorial: 'advertisement'});

                        onboardingService.setHolding(true);

                        window.onbeforeunload = () => {
                        };
                        window.onunload = () => {
                        };
                    },
                },
                actions: {
                    skip: false,
                    previousStep: false,
                    nextStep: false,
                    finish: false,
                },
                content: `Ấn vào Icon và chọn "Tài khoản"`,

                params: {
                    placement: 'bottom',

                    modifiers: [...modifiersDefault, ...flipModifier()],
                },

                before() {
                    if (userAgent.isEcosystemApple()) {
                        // // window.onbeforeunload = () => 'Are you sure to quit?';
                        userOnboardingService.hold({step: 1, tutorial: 'advertisement'}, false);
                    } else {
                        // // window.onbeforeunload = () => 'Are you sure to quit?';
                        window.onunload = () => userOnboardingService.hold({step: 1, tutorial: 'advertisement'});
                    }
                },
            },

            {
                target: '[data-obd-advertisement-step="2"]',
                header: {
                    title: 'Bước 2',
                    closeable: () => store.state.vueOnboarding.onboarding.flow === 'A',
                    confirmable: true,
                    confirmCallback: () => {
                        userOnboardingService.hold({step: 2, tutorial: 'advertisement'});
                        onboardingService.setHolding(true);
                        // window.onbeforeunload = () => {
                        // };
                        // window.onunload = () => {
                        // };
                    },
                },
                actions: {
                    skip: false,
                    previousStep: false,
                    nextStep: false,
                    finish: false,
                },
                content: 'Chọn "Hình thức quảng cáo"',
                params: {
                    placement: 'bottom',
                    enableScrolling: false,
                },

                before() {
                    if (userAgent.isEcosystemApple()) {
                        // window.onbeforeunload = () => 'Are you sure to quit?';
                        userOnboardingService.hold({step: 2, tutorial: 'advertisement'}, false);
                    } else {
                        // window.onbeforeunload = () => 'Are you sure to quit?';
                        window.onunload = () => userOnboardingService.hold({step: 2, tutorial: 'advertisement'});
                    }

                    return new Promise((resolve) => {
                        router.push({name: 'user-profile', params: {tab: 'general'}}).then(() => {
                            setTimeout(() => {
                                resolve();
                            }, 1200);
                        }).catch(() => resolve());
                    })
                },
            },

            {
                target: '[data-obd-advertisement-step="3"]',
                header: {
                    title: 'Bước 3',
                    closeable: () => store.state.vueOnboarding.onboarding.flow === 'A',
                    confirmable: true,
                    confirmCallback: () => {
                        userOnboardingService.hold({step: 3, tutorial: 'advertisement'});
                        onboardingService.setHolding(true);
                        window.onbeforeunload = () => {
                        };
                        window.onunload = () => {
                        };
                    },
                },
                actions: {
                    skip: false,
                    previousStep: false,
                    nextStep: false,
                    finish: false,
                },
                content: 'Chọn "Thêm hình thức"',
                params: {
                    placement: 'bottom',
                    enableScrolling: false,
                },

                before() {
                    if (userAgent.isEcosystemApple()) {
                        window.onbeforeunload = () => 'Are you sure to quit?';
                        userOnboardingService.hold({step: 3, tutorial: 'advertisement'}, false);
                    } else {
                        window.onbeforeunload = () => 'Are you sure to quit?';
                        window.onunload = () => userOnboardingService.hold({step: 3, tutorial: 'advertisement'});
                    }

                    return new Promise((resolve) => {
                        setTimeout(() => resolve(), 400);
                    });
                },
            },

            {
                target: '[data-obd-advertisement-step="4"]',
                header: {
                    title: 'Bước 4',
                    closeable: () => store.state.vueOnboarding.onboarding.flow === 'A',
                    confirmable: true,
                    confirmCallback: () => {
                        userOnboardingService.hold({step: 4, tutorial: 'advertisement'});
                        onboardingService.setHolding(true);
                        window.onbeforeunload = () => {
                        };
                        window.onunload = () => {
                        };
                    },
                },
                actions: {
                    skip: false,
                    previousStep: false,
                    nextStep: true,
                    finish: false,
                },
                content: 'Chọn “Nguồn Traffic"',

                params: {
                    placement: 'top',
                    enableScrolling: false,
                    modifiers: [...modifiersDefault, ...flipModifier()],
                },

                before() {
                    if (userAgent.isEcosystemApple()) {
                        window.onbeforeunload = () => 'Are you sure to quit?';
                        userOnboardingService.hold({step: 4, tutorial: 'advertisement'}, false);
                    } else {
                        window.onbeforeunload = () => 'Are you sure to quit?';
                        window.onunload = () => userOnboardingService.hold({step: 4, tutorial: 'advertisement'});
                    }
                },
            },

            {
                target: '[data-obd-advertisement-step="5"]',
                header: {
                    title: 'Bước 5',
                    closeable: () => store.state.vueOnboarding.onboarding.flow === 'A',
                    confirmable: true,
                    confirmCallback: () => {
                        userOnboardingService.hold({step: 5, tutorial: 'advertisement'});
                        onboardingService.setHolding(true);
                        window.onbeforeunload = () => {
                        };
                        window.onunload = () => {
                        };
                    },
                },
                actions: {
                    skip: false,
                    previousStep: true,
                    nextStep: true,
                    finish: false,
                },
                content: 'Chọn “Hình thức quảng cáo”',

                params: {
                    placement: 'top',
                    enableScrolling: false,
                    modifiers: [...modifiersDefault, ...flipModifier()],
                },

                before() {
                    if (userAgent.isEcosystemApple()) {
                        window.onbeforeunload = () => 'Are you sure to quit?';
                        userOnboardingService.hold({step: 5, tutorial: 'advertisement'}, false);
                    } else {
                        window.onbeforeunload = () => 'Are you sure to quit?';
                        window.onunload = () => userOnboardingService.hold({step: 5, tutorial: 'advertisement'});
                    }
                },
            },

            {
                target: '[data-obd-advertisement-step="6"]',
                header: {
                    title: 'Bước 6',
                    closeable: () => store.state.vueOnboarding.onboarding.flow === 'A',
                    confirmable: true,
                    confirmCallback: () => {
                        userOnboardingService.hold({step: 6, tutorial: 'advertisement'});
                        onboardingService.setHolding(true);
                        window.onbeforeunload = () => {
                        };
                        window.onunload = () => {
                        };
                    },
                },
                actions: {
                    skip: false,
                    previousStep: true,
                    nextStep: true,
                    finish: false,
                },
                content: 'Điền "Thông tin chi tiết”, sau đó ấn "Tiếp”',

                params: {
                    placement: 'top',
                    enableScrolling: false,
                    modifiers: [...modifiersDefault, ...flipModifier()],
                },

                before() {
                    if (userAgent.isEcosystemApple()) {
                        window.onbeforeunload = () => 'Are you sure to quit?';
                        userOnboardingService.hold({step: 6, tutorial: 'advertisement'}, false);
                    } else {
                        window.onbeforeunload = () => 'Are you sure to quit?';
                        window.onunload = () => userOnboardingService.hold({step: 6, tutorial: 'advertisement'});
                    }
                },
            },

            {
                target: '[data-obd-advertisement-step="7"]',
                header: {
                    title: 'Bước 7',
                    closeable: () => store.state.vueOnboarding.onboarding.flow === 'A',
                    confirmable: true,
                    confirmCallback: () => {
                        userOnboardingService.hold({step: 7, tutorial: 'advertisement'});
                        onboardingService.setHolding(true);
                        window.onbeforeunload = () => {
                        };
                        window.onunload = () => {
                        };
                    },
                },
                actions: {
                    skip: false,
                    previousStep: true,
                    nextStep: true,
                    finish: false,
                },
                content: 'Điền "Đường dẫn”, sau đó ấn "Tiếp”',

                params: {
                    placement: 'top',
                    enableScrolling: false,
                    modifiers: [...modifiersDefault, ...flipModifier()],
                },

                before() {
                    if (userAgent.isEcosystemApple()) {
                        window.onbeforeunload = () => 'Are you sure to quit?';
                        userOnboardingService.hold({step: 7, tutorial: 'advertisement'}, false);
                    } else {
                        window.onbeforeunload = () => 'Are you sure to quit?';
                        window.onunload = () => userOnboardingService.hold({step: 7, tutorial: 'advertisement'});
                    }
                },
            },

            {
                target: '[data-obd-advertisement-step="8"]',
                header: {
                    title: 'Bước 8',
                    closeable: () => store.state.vueOnboarding.onboarding.flow === 'A',
                    confirmable: true,
                    confirmCallback: () => {
                        userOnboardingService.hold({step: 8, tutorial: 'advertisement'});
                        onboardingService.setHolding(true);
                        window.onbeforeunload = () => {
                        };
                        window.onunload = () => {
                        };
                    },
                },
                actions: {
                    skip: false,
                    previousStep: true,
                    nextStep: true,
                    finish: false,
                },
                content: 'Ấn nút "Chọn ảnh” và tải lên hình ảnh của hình thức quảng cáo. <br/> Khi đã hoàn thành, ấn "Tiếp”.',

                params: {
                    placement: window.innerWidth < 768 ? 'bottom' : 'right',
                    enableScrolling: true,
                },

                before() {
                    if (userAgent.isEcosystemApple()) {
                        window.onbeforeunload = () => 'Are you sure to quit?';
                        userOnboardingService.hold({step: 8, tutorial: 'advertisement'}, false);
                    } else {
                        window.onbeforeunload = () => 'Are you sure to quit?';
                        window.onunload = () => userOnboardingService.hold({step: 8, tutorial: 'advertisement'});
                    }
                },
            },

            {
                target: '[data-obd-advertisement-step="9"]',
                header: {
                    title: 'Bước 9',
                    closeable: () => store.state.vueOnboarding.onboarding.flow === 'A',
                    confirmable: true,
                    confirmCallback: () => {

                        document.body.classList.remove("v-tour--advertising-vh");

                        userOnboardingService.hold({step: 9, tutorial: 'advertisement'});
                        onboardingService.setHolding(true);
                        window.onbeforeunload = () => {
                        };
                        window.onunload = () => {
                        };
                    },
                },
                actions: {
                    skip: false,
                    previousStep: false,
                    nextStep: false,
                    finish: false,
                },
                content: 'Ấn “Lưu hình thức”',

                params: {
                    placement: 'bottom',
                    enableScrolling: true,
                },

                before() {
                    if (userAgent.isEcosystemApple()) {
                        window.onbeforeunload = () => 'Are you sure to quit?';
                        userOnboardingService.hold({step: 9, tutorial: 'advertisement'}, false);
                    } else {
                        window.onbeforeunload = () => 'Are you sure to quit?';
                        window.onunload = () => userOnboardingService.hold({step: 9, tutorial: 'advertisement'});
                    }

                    return new Promise((resolve) => {
                        setTimeout(() => {
                            resolve();
                        }, 400);
                    })
                },
            },
        ],

        create_link: [
            {
                target: '[data-obd-create-link-step="1"]',
                header: {
                    title: 'Bước 1',
                    closeable: () => store.state.vueOnboarding.onboarding.flow === 'A',
                    confirmable: true,
                    confirmCallback: () => {
                        userOnboardingService.hold({step: 1, tutorial: 'create_link'});
                        onboardingService.setHolding(true);
                        // window.onbeforeunload = () => {
                        // };
                        // window.onunload = () => {
                        // };
                    },
                },
                actions: {
                    skip: false,
                    previousStep: false,
                    nextStep: false,
                    finish: false,
                },
                content: `
                    Sau đây bạn sẽ được hướng dẫn tạo link.
                    Đầu tiên, vào mục <span class='font-bold text-primary'>“Chiến dịch”</span>, tìm Chiến dịch muốn chạy, sau đó ấn "Tạo link”
                `,
                before: () => {
                    if (userAgent.isEcosystemApple()) {
                        // window.onbeforeunload = () => 'Are you sure to quit?';
                        userOnboardingService.hold({step: 1, tutorial: 'create_link'}, false);
                    } else {
                        // window.onbeforeunload = () => 'Are you sure to quit?';
                        window.onunload = () => userOnboardingService.hold({step: 1, tutorial: 'create_link'});
                    }

                    return new Promise((resolve) => {
                        if (router.currentRoute.name !== 'offer') {
                            router.push({name: 'offer'}).then(() => resolve());
                        } else {
                            resolve();
                        }
                    });
                },
            },
            {
                target: '[data-obd-create-link-step="2"]',
                header: {
                    title: 'Bước 2',
                    closeable: () => store.state.vueOnboarding.onboarding.flow === 'A',
                    confirmable: true,
                    confirmCallback: () => {
                        userOnboardingService.hold({step: 2, tutorial: 'create_link'});
                        onboardingService.setHolding(true);
                        // window.onbeforeunload = () => {
                        // };
                        // window.onunload = () => {
                        // };
                    },
                },
                actions: {
                    skip: false,
                    previousStep: false,
                    nextStep: false,
                    finish: false,
                },
                content: `
                    Kiểm tra các thông tin như "Tên miền", "Landing Page”. Sau đó ấn "Tạo link”
                `,

                params: {
                    enableScrolling: false,
                    placement: 'bottom-end',
                    modifiers: [
                        ...modifiersDefault,
                        ...flipModifier({fallbackPlacements: ['top'], allowedAutoPlacements: ['top', 'bottom']}),
                    ],
                },

                before() {
                    // With safari browser, we need to send request when user at current step
                    // To tracking current step of user
                    if (userAgent.isEcosystemApple()) {
                        // window.onbeforeunload = () => 'Are you sure to quit?';
                        userOnboardingService.hold({step: 2, tutorial: 'create_link'}, false);
                    } else {
                        // window.onbeforeunload = () => 'Are you sure to quit?';
                        window.onunload = () => userOnboardingService.hold({step: 2, tutorial: 'create_link'});
                    }

                    // Before it, to clear session caching previous onboarding (if have)
                    const {clearItem} = useSessionStorage("mo-offer-note");
                    clearItem();

                    return new Promise((resolve) => {
                        return setTimeout(() => {
                            resolve();
                        }, 500);
                    });
                },
            },
            {
                target: '[data-obd-create-link-step="3"]',
                header: {
                    title: 'Bước 3',
                    closeable: () => store.state.vueOnboarding.onboarding.flow === 'A',
                    confirmable: true,
                    confirmCallback: () => {
                        userOnboardingService.hold({step: 3, tutorial: 'create_link'});
                        onboardingService.setHolding(true);
                        // window.onbeforeunload = () => {
                        // };
                        // window.onunload = () => {
                        // };
                    },
                },
                actions: {
                    skip: false,
                    previousStep: false,
                    nextStep: false,
                    finish: false,
                },
                content: `
                    Đọc kỹ "Thông tin điều khoản”. Sau đó ấn "Đồng ý”.
                `,
                params: {
                    highlight: true,
                    placement: 'bottom',

                    modifiers: [...flipModifier()],
                },
                before: () => {
                    if (userAgent.isEcosystemApple()) {
                        // window.onbeforeunload = () => 'Are you sure to quit?';
                        userOnboardingService.hold({step: 3, tutorial: 'create_link'}, false);
                    } else {
                        // window.onbeforeunload = () => 'Are you sure to quit?';
                        window.onunload = () => userOnboardingService.hold({step: 3, tutorial: 'create_link'});
                    }

                    // Holding for load & open modal term, condition
                    return new Promise((resolve) => {
                        setTimeout(() => {
                            resolve();
                        }, 600);
                    });
                },
            },
            {
                target: '[data-obd-create-link-step="4"]',
                header: {
                    title: 'Hoàn tất',
                    closeable: () => store.state.vueOnboarding.onboarding.flow === 'A',
                    confirmable: true,
                    confirmCallback: () => {
                        userOnboardingService.hold({step: 4, tutorial: 'create_link'});
                        onboardingService.setHolding(true);
                        // window.onbeforeunload = () => {
                        // };
                        // window.onunload = () => {
                        // };
                    },
                },
                actions: {
                    skip: false,
                    previousStep: false,
                    nextStep: false,
                    finish: false,
                },
                content: `
                    Dưới đây là link bạn vừa tạo. 
                    Ấn vào biểu tượng <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <rect x="0.541992" width="22.9156" height="21.7978" rx="6" fill="url(#pattern0)"/>
                    <defs>
                    <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlink:href="#image0_1762_516368" transform="scale(0.0243902 0.025641)"/>
                    </pattern>
                    <image id="image0_1762_516368" width="41" height="39" xlink:href="data:image/png;base64,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"/>
                    </defs>
                    </svg> để sao chép và bắt đầu đẩy chiến dịch nào!
                `,
                params: {
                    placement: 'top',
                },
                before: () => {
                    if (userAgent.isEcosystemApple()) {
                        // window.onbeforeunload = () => 'Are you sure to quit?';
                        userOnboardingService.hold({step: 4, tutorial: 'create_link'}, false);
                    } else {
                        // window.onbeforeunload = () => 'Are you sure to quit?';
                        window.onunload = () => userOnboardingService.hold({step: 4, tutorial: 'create_link'});
                    }

                    // After fetch api, hold 200ms to find focus element
                    return new Promise((resolve) => {
                        setTimeout(() => {
                            resolve();
                        }, 600);
                    });
                },
            },
        ],

        dashboard_desktop: [
            {
                target: '[data-obd-dashboard-step="1"]',
                header: {
                    title: 'home.userOnboarding.step1.title',
                    stepText: '1/6',
                },
                actions: {
                    exit: true,
                    nextStep: true,
                    finish: false,
                },
                content: 'home.userOnboarding.step1.content',

                params: {
                    enableScrolling: false,
                    placement: 'bottom',

                    modifiers: [...modifiersDefault, ...flipModifier()],
                },
                before: () => {
                    if (userAgent.isEcosystemApple()) {
                        // window.onbeforeunload = () => 'Are you sure to quit?';
                    } else {
                        // window.onbeforeunload = () => 'Are you sure to quit?';
                    }
                }
            },
            {
                target: '[data-obd-dashboard-step="2"]',
                header: {
                    title: 'home.userOnboarding.step2.title',
                    stepText: '2/6',
                },
                actions: {
                    exit: true,
                    nextStep: true,
                    finish: false,
                },
                content: 'home.userOnboarding.step2.content',

                params: {
                    enableScrolling: false
                },
            },
            {
                target: '[data-obd-dashboard-step="3"]',
                header: {
                    title: 'home.userOnboarding.step3.title',
                    stepText: '3/6',
                },
                actions: {
                    exit: true,
                    nextStep: true,
                    finish: false,
                },
                content: 'home.userOnboarding.step3.content',

                params: {
                    enableScrolling: false
                },
            },
            {
                target: '[data-obd-dashboard-step="4"]',
                header: {
                    title: 'home.userOnboarding.step4.title',
                    stepText: '4/6',
                },
                actions: {
                    exit: true,
                    nextStep: true,
                    finish: false,
                },
                content: 'home.userOnboarding.step4.content',

                params: {
                    enableScrolling: false
                },
            },
            {
                target: '[data-obd-dashboard-step="5"]',
                header: {
                    title: 'home.userOnboarding.step5.title',
                    stepText: '5/6',
                },
                actions: {
                    exit: true,
                    nextStep: true,
                    finish: false,
                },
                content: 'home.userOnboarding.step5.content',

                params: {
                    enableScrolling: false
                },
            },
            {
                target: '[data-obd-dashboard-step="6"]',
                header: {
                    title: 'home.userOnboarding.step6.title',
                    stepText: '6/6',
                },
                actions: {
                    exit: true,
                    nextStep: true,
                    finish: false,
                },
                content: 'home.userOnboarding.step6.content',

                params: {
                    enableScrolling: false
                },
            },
            {
                target: '[data-obd-dashboard-step="7"]',
                header: {
                    title: 'home.userOnboarding.stepMessenger.title',
                    stepText: '',
                },
                actions: {
                    exit: false,
                    nextStep: false,
                    finish: true,
                },
                content: 'home.userOnboarding.stepMessenger.content',

                params: {
                    enableScrolling: false
                },
            },
        ],

        dashboard_mobile: [
            {
                target: '[data-obd-dashboard-step="1"]',
                header: {
                    title: 'home.userOnboarding.step1.title',
                    stepText: '1/6',
                },
                actions: {
                    exit: true,
                    nextStep: true,
                    finish: false,
                },
                content: 'home.userOnboarding.step1.content',

                params: {
                    enableScrolling: false,
                },
                before: () => {
                    if (userAgent.isEcosystemApple()) {
                        // window.onbeforeunload = () => 'Are you sure to quit?';
                    } else {
                        // window.onbeforeunload = () => 'Are you sure to quit?';
                    }
                }
            },
            {
                target: '[data-obd-dashboard-step="2"]',
                content: 'home.userOnboarding.stepToggle.title',

                params: {
                    enableScrolling: false,
                },
            },
            {
                target: '[data-obd-dashboard-step="3"]',
                header: {
                    title: 'home.userOnboarding.step2.title',
                    stepText: '2/6',
                },
                actions: {
                    exit: true,
                    nextStep: true,
                    finish: false,
                },
                content: 'home.userOnboarding.step2.content',

                params: {
                    enableScrolling: false
                },
            },
            {
                target: '[data-obd-dashboard-step="4"]',
                header: {
                    title: 'home.userOnboarding.step3.title',
                    stepText: '3/6',
                },
                actions: {
                    exit: true,
                    nextStep: true,
                    finish: false,
                },
                content: 'home.userOnboarding.step3.content',

                params: {
                    enableScrolling: false
                },
            },
            {
                target: '[data-obd-dashboard-step="5"]',
                header: {
                    title: 'home.userOnboarding.step4.title',
                    stepText: '4/6',
                },
                actions: {
                    exit: true,
                    nextStep: true,
                    finish: false,
                },
                content: 'home.userOnboarding.step4.content',

                params: {
                    enableScrolling: false
                },
            },
            {
                target: '[data-obd-dashboard-step="6"]',
                header: {
                    title: 'home.userOnboarding.step5.title',
                    stepText: '5/6',
                },
                actions: {
                    exit: true,
                    nextStep: true,
                    finish: false,
                },
                content: 'home.userOnboarding.step5.content',

                params: {
                    enableScrolling: false
                },
            },
            {
                target: '[data-obd-dashboard-step="7"]',
                header: {
                    title: 'home.userOnboarding.step6.title',
                    stepText: '6/6',
                },
                actions: {
                    exit: true,
                    nextStep: true,
                    finish: false,
                },
                content: 'home.userOnboarding.step6.content',

                params: {
                    enableScrolling: false
                },
            },
            {
                target: '[data-obd-dashboard-step="8"]',
                header: {
                    title: 'home.userOnboarding.stepMessenger.title',
                    stepText: '',
                }, actions: {
                    exit: false,
                    nextStep: false,
                    finish: true,
                },
                content: 'home.userOnboarding.stepMessenger.content',

                params: {
                    enableScrolling: false
                },
            },
        ],

        campaign: [
            {
                target: '[data-obd-create-link-step="1"]',
                header: {
                    title: 'offer.userOnboarding.campaign.step1.title',
                    closeable: () => true,
                    confirmable: true,
                },
                actions: {
                    skip: false,
                    previousStep: false,
                    nextStep: false,
                    finish: false,
                },
                content: 'offer.userOnboarding.campaign.step1.content',
                before: () => {
                    if (userAgent.isEcosystemApple()) {
                        // window.onbeforeunload = () => 'Are you sure to quit?';
                    } else {
                        // window.onbeforeunload = () => 'Are you sure to quit?';
                    }
                }
            },
            {
                target: '[data-obd-create-link-step="2"]',
                header: {
                    title: 'offer.userOnboarding.campaign.step2.title',
                    closeable: () => true,
                    confirmable: true,
                },
                actions: {
                    skip: false,
                    previousStep: false,
                    nextStep: false,
                    finish: false,
                },
                content: 'offer.userOnboarding.campaign.step2.content',

                params: {
                    enableScrolling: false,
                    placement: 'bottom-end',
                    modifiers: [
                        ...modifiersDefault,
                        ...flipModifier({fallbackPlacements: ['top'], allowedAutoPlacements: ['top', 'bottom']}),
                    ],
                },
                before: () => {
                    // Before it, to clear session caching previous onboarding (if have)
                    const {clearItem} = useSessionStorage("mo-offer-note");
                    clearItem();

                    return new Promise((resolve) => {
                        return setTimeout(() => {
                            resolve();
                        }, 500);
                    });
                }
            },
            {
                target: '[data-obd-create-link-step="3"]',
                header: {
                    title: 'offer.userOnboarding.campaign.step3.title',
                    closeable: () => true,
                    confirmable: true,
                },
                actions: {
                    skip: false,
                    previousStep: false,
                    nextStep: false,
                    finish: false,
                },
                content: 'offer.userOnboarding.campaign.step3.content',
                params: {
                    highlight: true,
                    placement: 'bottom',

                    modifiers: [...flipModifier()],
                },
                before: () => {
                    if (userAgent.isEcosystemApple()) {
                        userOnboardingService.hold({step: 3, tutorial: 'campaign'}, false);
                    } else {
                        window.onunload = () => userOnboardingService.hold({step: 3, tutorial: 'campaign'});
                    }

                    // Holding for load & open modal term, condition
                    return new Promise((resolve) => {
                        setTimeout(() => {
                            resolve();
                        }, 600);
                    });
                },
            },
            {
                target: '[data-obd-create-link-step="4"]',
                header: {
                    title: 'offer.userOnboarding.campaign.step4.title',
                    closeable: () => true,
                    confirmable: true,
                },
                actions: {
                    skip: false,
                    previousStep: false,
                    nextStep: false,
                    finish: false,
                },
                content: 'offer.userOnboarding.campaign.step4.content',
                params: {
                    placement: 'top',
                },
            },
        ],
    },
};



// WEBPACK FOOTER //
// ./src/core/config/userOnboardingConstants.js